var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { id: "container-entities" } },
    [
      _c("div", { staticClass: "row" }, [
        _c("h3", { staticClass: "col-12" }, [_vm._v("Entidades")]),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("WareHousesFilters", {
              attrs: {
                value: _vm.filters,
                onChange: _vm.onChangeFilters,
                clear: _vm.clearFilters
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 text-left mb-3" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "has-permission",
                    rawName: "v-has-permission",
                    value: "ED202",
                    expression: "'ED202'"
                  }
                ],
                attrs: {
                  pill: "",
                  variant: "primary",
                  size: "sm",
                  "data-cy": "add"
                },
                on: {
                  click: function($event) {
                    return _vm.addEntity()
                  }
                }
              },
              [
                _c("b-icon", { attrs: { icon: "plus-circle-fill" } }),
                _vm._v(" Agregar Entidad ")
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("b-table", {
            attrs: {
              hover: "",
              fields: _vm.fieldEntities,
              items: _vm.filteredEntities,
              "tbody-tr-attr": { "data-cy": "file" }
            },
            scopedSlots: _vm._u([
              {
                key: "cell(actions)",
                fn: function(row) {
                  return [
                    _c("div", { staticClass: "row justify-content-end" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Editar Entidad",
                              expression: "'Editar Entidad'"
                            }
                          ]
                        },
                        [
                          _c("b-icon", {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED203",
                                expression: "'ED203'"
                              }
                            ],
                            staticClass: "h3 m-2",
                            attrs: { icon: "pencil", "data-cy": "edit" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.editEntity(row.item)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Eliminar Entidad",
                              expression: "'Eliminar Entidad'"
                            }
                          ]
                        },
                        [
                          _c("b-icon", {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED204",
                                expression: "'ED204'"
                              }
                            ],
                            staticClass: "h3 m-2",
                            attrs: { icon: "trash", "data-cy": "remove" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.showAlertDeleteEntity(row.item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.fetchEntities()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v("10")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("EntitiesPagination", {
              attrs: { show: _vm.pagination.pages },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "newEntity",
          attrs: {
            id: "new-entity",
            title: _vm.newitem.isEdit ? "Editar Entidad" : "Nueva Entidad",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "row mb-5" }, [
            _c(
              "form",
              { staticClass: "col-12", attrs: { "data-vv-scope": "newitem" } },
              [
                _c(
                  "div",
                  { staticClass: "col-md-12 mt-3" },
                  [
                    _c("label", [_vm._v("Código")]),
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:3",
                          expression: "'required|min:3'"
                        }
                      ],
                      attrs: {
                        placeholder: "Ingresa Código",
                        size: "md",
                        name: "code",
                        state: _vm.errors.has("newitem.code") ? false : null
                      },
                      model: {
                        value: _vm.newitem.code,
                        callback: function($$v) {
                          _vm.$set(_vm.newitem, "code", $$v)
                        },
                        expression: "newitem.code"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("newitem.code")) + " "
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-12 mt-3" },
                  [
                    _c("label", [_vm._v("Nombre")]),
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:3",
                          expression: "'required|min:3'"
                        }
                      ],
                      attrs: {
                        placeholder: "Ingresa Nombre",
                        size: "md",
                        name: "name",
                        state: _vm.errors.has("newitem.name") ? false : null
                      },
                      model: {
                        value: _vm.newitem.name,
                        callback: function($$v) {
                          _vm.$set(_vm.newitem, "name", $$v)
                        },
                        expression: "newitem.name"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("newitem.name")) + " "
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-12 mt-3" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary pull-right ml-3 mt-5",
                        attrs: { size: "md", "data-cy": "next-button" },
                        on: {
                          click: function($event) {
                            return _vm.saveEntity()
                          }
                        }
                      },
                      [
                        _c("feather-icon", { attrs: { icon: "SaveIcon" } }),
                        _vm._v(" Guardar ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }